import ElevatorTypology from './components/ElevatorTypology/ElevatorTypology';
import GarageTypology from './components/GarageTypology/GarageTypology';
import ValidationGoodZone from './components/ValidationGoodZone/ValidationGoodZone';
import ValidationHistoricalBusinessInformation from './components/ValidationHistoricalBusinessInformation/ValidationHistoricalBusinessInformation';
import { ValidationHistoricalSales } from './components/ValidationHistoricalSales/ValidationHistoricalSales';
import ValidationRoomsBathrooms from './components/ValidationRoomsBathrooms/ValidationRoomsBathrooms';
import ErrorBoundary from '../../../../components/ErrorBoundary/ErrorBoundary';
const country = localStorage.getItem('country');

// Cada validación se aísla por separado: si una respuesta del API viene
// incompleta, se pierde esa sección y no el resto de la pestaña.
const ValidationsTab = () => {
  return (
    <div>
      <ErrorBoundary name="ValidationGoodZone">
        <ValidationGoodZone />
      </ErrorBoundary>
      {country === 'CO' && (
        <ErrorBoundary name="ValidationRoomsBathrooms">
          <ValidationRoomsBathrooms />
        </ErrorBoundary>
      )}
      <ErrorBoundary name="ValidationHistoricalSales">
        <ValidationHistoricalSales />
      </ErrorBoundary>
      <ErrorBoundary name="ValidationHistoricalBusinessInformation">
        <ValidationHistoricalBusinessInformation />
      </ErrorBoundary>
      {country === 'CO' && (
        <ErrorBoundary name="ElevatorTypology">
          <ElevatorTypology />
        </ErrorBoundary>
      )}
      {country === 'CO' && (
        <ErrorBoundary name="GarageTypology">
          <GarageTypology />
        </ErrorBoundary>
      )}
    </div>
  );
};

export default ValidationsTab;
